import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/dev/cobrancas/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router notFound contract.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV
    ? lazyScreen(() => import('./-page'), 'BillingDevPage')
    : () => null,
});
